<div class="action-menu" [ngStyle]="{ top: topPosition, right: rightPosition }">
  <div
    class="action-menu__holder"
    inClickOutside
    (clickOutside)="handleOutSideClick()"
    (click)="openMenu(); $event.stopPropagation()"
  >
    <img src="assets/images/more.svg" alt="..." />
  </div>
  <ul [ngClass]="isOpen ? 'active' : ''">
    <li (click)="handleEdit();$event.stopPropagation()">
      <picture>
        <img src="assets/images/edit.svg" alt="edit" />
      </picture>
      Edit
    </li>
    <li (click)="handleDelete();$event.stopPropagation()">
      <picture>
        <img src="assets/images/transh.svg" alt="transh" />
      </picture>
      Delete
    </li>
  </ul>
</div>
